<template>
  <div>
    <spacer :y="6"/>
    <loader-simple :flag="flag.loader">
      <div v-show="!flag.loader">

        <ul>
          <contents-box>
            <loader-simple :flag="flag.isOnline">
              <div v-if="reserves.length">
                <stack-item
                  space="2"
                  :id="`reserve_${row.id}`"
                  v-for="row in reserves" :key="row.id">
                  <div :class="$style.time">
                    <i class="fa-regular fa-clock"/>
                    <p>{{ formatTimestamp(row.schedule.date, `YYYY年MM月DD日（${getWeekDayLabel(row.schedule.date, 'short')}）HH:00`) }}</p>
                    <div :class="$style.counseling_wrap">
                      <i
                        v-if="reserveCounselingTypes[row.id] === 1"
                        class="fa-regular fa-laptop"
                        :class="[
                          $style.counseling_icon,
                          $style.online,
                        ]"
                      ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                      <i
                        v-if="isVirtual(row.id)"
                        class="fa-solid fa-vr-cardboard"
                        :class="[
                          $style.counseling_icon,
                          $style.virtual,
                        ]"
                      ></i>
                    </div>
                  </div>
                  <loader-simple :flag="loadingIds.includes(row.id) && !openflags.includes(row.id)">
                    <user-box
                      :user="row.fromUser"
                      :showCocomoniBtn="true"
                      :ownUser="user"
                      :bg="userBoxColor(row.fromUser)"
                      :showId="true"
                      :link="`/teacher/history/${row.fromUser.id}`"
                      :targetBlank="true"
                      type="inner"
                      saveTab="reserve">
                      <template v-slot:btn>
                        <div :class="$style.icon_wrap">
                          <i
                            class="fa-solid"
                            :class="[$style.icon, {
                              'fa-plus': !openIds.includes(row.id),
                              'fa-minus': openIds.includes(row.id),
                            }]"
                            v-on:click="changeOpenIds(row.id), getMostRect(row)" />
                        </div>
                      </template>
                      <template v-slot:main>
                        <div v-if="openIds.includes(row.id) && openflags.includes(row.id)">
                          <spacer :y="3"/>
                          <ul :class="$style.detail">
                            <li>
                              <label-box label="担当" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content">{{ row.toUser.username }}（{{ row.toUser.account_type === 21 ? '医師' : '心理士' }}）</p>
                            </li>
                            <li v-if="row.meeting">
                              <label-box label="URL" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content"><a :href="row.meeting.join_url" target="_blank">{{ row.meeting.join_url }}</a></p>
                            </li>
                            <!-- virtualCastProps 行を欠くと内側の deref で一覧ごと描画が落ちるため、上のオンライン URL 行（row.meeting）と同様に行単位で伏せる -->
                            <li v-if="isVirtual(row.id) && row.toUser?.virtualCastProp">
                              <label-box label="URL" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content"><a :href="getVirtualCastMedicalRooomURL(row.toUser.virtualCastProp.virtual_cast_room_key)" target="_blank">{{ getVirtualCastMedicalRooomURL(row.toUser.virtualCastProp.virtual_cast_room_key) }}</a></p>
                            </li>
                            <li v-if="isVirtual(row.id) && row.fromUser.student && row.fromUser.virtualCastProp">
                              <label-box label="VC ID" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div>
                                <p :class="$style.content">{{ row.fromUser.virtualCastProp.virtual_cast_id }}</p>
                                <p :class="$style.virtualcast_url"><a :href="getVirtualCastUserURL(row.fromUser.virtualCastProp.virtual_cast_id)" target="_branc">{{ getVirtualCastUserURL(row.fromUser.virtualCastProp.virtual_cast_id) }}</a></p>
                              </div>
                            </li>
                            <li>
                              <label-box label="お悩み" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="[$style.value, $style.type, hasSubTypesRecorded(row) ? $style.typeCompany : '']">
                                <p
                                  v-for="typeNum in sortWorryTypes(row.type)"
                                  :key="typeNum">{{ getWorryTypeLabel(typeNum, !!row?.fromUser?.school?.[0]?.is_company, 'reserve') }}<span v-if="row.other_text && typeNum === 6">（{{ row.other_text }}）</span>
                                  <span v-if="getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporateSchool(row?.fromUser?.school), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(typeNum, getRecordedSubs(row, typeNum), isCorporateSchool(row?.fromUser?.school), 'reserve') }}</span>
                                </p>
                              </div>
                            </li>
                            <li class="n2br" v-if="row.memos.customer.length">
                              <label-box label="相談内容" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <p :class="$style.content">{{ row.memos.customer[0].memo }}</p>
                            </li>
                            <!-- who5Answers 行を持たない予約では内側の answers 参照が無ガードで落ち、一覧ごと描画されないためラベルごと伏せる -->
                            <li v-if="row.who5Answer">
                              <label-box label="ココモニ" color="gray" size="sm" :class="$style.label" smAlign="left"/>
                              <div :class="$style.content">
                                <ul :class="$style.who5">
                                  <li v-for="(item, i) in row.who5Answer.answers" :key="item">
                                    <p>{{ helper.master.who5.items[i].label }}</p>
                                    <p :class="$style.who5_answer">{{ helper.master.who5.labels[item] }}</p>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="n2br">
                              <label-box label="コメント" color="gray" size="sm" :class="$style.label"/>
                              <div :class="$style.content" v-if="row.memos.teacher && row.memos.teacher.length">
                                <!-- 投稿者「[管理者/副管理者]・氏名 [最終更新日時]」を表示（11は文言統一で「主」を付けない・職階は出さない） -->
                                <p :class="$style.postUser">{{ getMemoAuthorName(row.memos.teacher[0]) }} [{{ filterMoment(row.memos.teacher[0].updated_at, 'YYYY.MM.DD HH:mm') }}]</p>
                                <p v-html="row.memos.teacher[0].memo"></p>
                              </div>
                              <p :class="$style.content" v-else>登録なし</p>
                            </li>
                            <li class="n2br" :class="$style.fReserve_center">
                              <label-box label="オンライン<br>バーチャル<br>予約" color="gray" size="sm" :class="[$style.label, $style.fReserve_content]" smAlign="left"></label-box>
                              <ul v-if="futureReserveMap[row.id] && futureReserveMap[row.id].length" :class="$style.nearest_box">
                                <li v-for="fReserve in futureReserveMap[row.id]" :key="fReserve">
                                  <table>
                                    <tr>
                                      <td :class="$style.fReserve_label">申込日</td>
                                      <td :class="$style.fReserve_value">{{ formatTimestamp(fReserve.created_at, 'YYYY/MM/DD  HH:mm') }}</td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">実施情報</td>
                                      <td :class="[$style.fReserve_value, $style.counseling_wrap]">
                                        {{ formatTimestamp(fReserve.schedule.date, `YYYY/MM/DD  HH:00〜HH:45`) }}　{{ fReserve.toUser.username }}
                                        <i
                                          v-if="reserveCounselingTypes[fReserve.id] === 1"
                                          class="fa-regular fa-laptop"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.online,
                                          ]"
                                        ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                                        <i
                                          v-if="isVirtual(fReserve.id)"
                                          class="fa-solid fa-vr-cardboard"
                                          :class="[
                                            $style.counseling_icon,
                                            $style.virtual,
                                          ]"
                                        ></i>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">お悩み</td>
                                      <td :class="$style.fReserve_value"><span v-for="wType in sortWorryTypes(fReserve.type)" :key="wType" :class="hasSubTypesRecorded(fReserve) ? $style.fReserveTypeCompany : ''">{{ getWorryTypeLabel(wType, !!row?.fromUser?.school?.[0]?.is_company, 'reserve') }}
                                        <span v-if="getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporateSchool(row?.fromUser?.school), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporateSchool(row?.fromUser?.school), 'reserve') }}</span><template v-if="!hasSubTypesRecorded(fReserve)">　</template></span></td>
                                    </tr>
                                    <tr>
                                      <td :class="$style.fReserve_label">相談内容</td>
                                      <td :class="$style.fReserve_value">{{ getCustomerMemo(fReserve.memos.customer) }}</td>
                                    </tr>
                                  </table>
                                </li>
                              </ul>
                              <p v-else :class="$style.fReserve_none">以降の予約無し</p>
                            </li>
                          </ul>
                          <spacer :y="2"/>
                          <btn-container v-if="row.flag === 1">
                            <basic-btn
                              size="sm"
                              :to="getTeacherReserveURL(row.id)">
                              先生に伝える</basic-btn>
                            <spacer :x="2"/>
                            <basic-btn
                              size="sm"
                              tag="button"
                              addClass="danger"
                              @click="cancelReserve(row)">キャンセルする</basic-btn>
                          </btn-container>
                        </div>
                      </template>
                    </user-box>
                    <div
                      :class="$style.new"
                      v-if="user.readflags && !user.readflags.reserves.includes(row.id)">NEW</div>
                  </loader-simple>
                </stack-item>
              </div>
              <p v-if="!flag.isOnline && !reserves.length">現在、オンライン健康相談の予約はありません。</p>
            </loader-simple>
          </contents-box>
        </ul>
      </div>
    </loader-simple>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import moment from 'moment';

export default {
  name: 'teacher-reserve',
  mixins: [cf, corporateSchool],
  components: {
    StackItem,
    ContentsBox,
    UserBox,
    Spacer,
    LabelBox,
    LoaderSimple,
    BtnContainer,
    BasicBtn,
  },
  data() {
    return {
      flag: {
        loader: true,
        isOnline: true,
      },
      openflags: [],
      openIds: [],
      loadingIds: [],
      dateSortedReserves: {},
      reserves: [],
      reserveCounselingTypes: {}, // key: reserve_id, value: counseling_type
      futureReserveMap: {}, // key: reserve_id, value: future_reserve_array
    };
  },
  created() {
    this.getReserves();
  },
  computed: {
    ...mapState(['user', 'helper']),
  },
  methods: {
    // 予約を取得(軽量メソッド)
    async getReserves() {
      const params = {
        school_id: this.user.school[0].id,
        flags: [1],
        limit: 100,
        page: 1,
      };
      this.axios({
        method: 'GET',
        url: '/v2/reserve/get/minimumList',
        params,
      })
        .then((response) => {
          const res = response.data.result;
          this.reserves = cf.upSortReserves(res.reserve);
          // 取得直後のデータで、それぞれの予約がオンライン/バーチャルどちらの健康相談なのかを控えておく（+アイコンクリック時にgetDetailによってreestve,.typeが上書きされてしまうことへのケア）
          this.setReserveCounselingType();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loader = false;
          this.flag.isOnline = false;
          // 学校コメント保存後の着地時に query.open があれば対象予約を自動展開＋スクロールする。
          // 一覧は <div v-show="!flag.loader"> 配下のため、flag.loader=false（表示確定）後に呼ばないと
          // getBoundingClientRect が 0 を返しスクロールできない。counseling_type 依存の setReserveCounselingType() は .then で先行済み。
          this.scroll2OpenItem();
        });
    },
    setReserveCounselingType() {
      this.reserves.forEach((reserve) => {
        this.reserveCounselingTypes[reserve.id] = reserve.type.counseling_type;
      });
    },
    isVirtual(reserveId) {
      return this.reserveCounselingTypes[reserveId] === 3;
    },
    // 予約の詳細情報を取得
    async getReserveDetail(id) {
      const params = {
        id,
        isRisk: 1,
        counseling_type: this.reserveCounselingTypes[id],
      };
      await this.axios({
        method: 'GET',
        url: '/v1/reserve/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data.reserve;
          this.openflags.push(id);
          this.reserves.forEach((elem, i) => {
            if (elem.id === res.id) this.reserves[i] = res;
          });
        })
        .catch((error) => {
          if (error.message) console.log(error);
          else console.log(error);
        });
    },
    dateSortReserves() {
      if (this.user.counseling.reserves.length) {
        const reserves = cf.upSortReserves(this.user.counseling.reserves);
        const len = reserves.length - 1;
        reserves.forEach((row, i) => {
          if (row.flag === 1) {
            const date = this.formatTimestamp(row.schedule.date, 'YYYY/MM/DD');
            if (this.dateSortedReserves[date]) {
              this.dateSortedReserves[date].push(row);
            } else {
              this.dateSortedReserves[date] = [];
              this.dateSortedReserves[date].push(row);
            }
          }
          if (len === i) this.flag.loader = false;
        });
      } else {
        this.flag.loader = false;
      }
    },
    async changeOpenIds(id) {
      if (this.openIds.includes(id)) {
        const idx = this.openIds.indexOf(id);
        this.openIds.splice(idx, 1);
      } else {
        this.loadingIds.push(id);
        this.openIds.push(id);
        this.getReserveDetail(id);
        if (this.user.readflags && !this.user.readflags.reserves.includes(id)) {
          this.registReadFlag(id);
        }
      }
    },

    // query.open で指定された予約を自動展開し、その行までスクロールする（学校コメント保存後の予約タブ着地用）。
    // changeOpenIds が内部で getReserveDetail → openflags push まで連鎖するため、手動の「＋」クリックと同一挙動になる。
    scroll2OpenItem() {
      const { query } = this.$route;
      if (!query || !query.open) return;
      const id = Number(query.open);
      const row = this.reserves.find((item) => item.id === id);
      if (!row) return; // 対象が一覧に無い（limit 外/対象なし）場合は一覧着地のままにする（グレースフル退化）
      this.changeOpenIds(id);
      this.getMostRect(row);
      this.$nextTick(() => {
        const elem = document.getElementById(`reserve_${id}`);
        if (!elem) return;
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      });
    },

    // 該当利用者の直近の未実施オンライン/バーチャル健康相談を取得
    async getMostRect(reserve) {
      try {
        const futureReserve = [];
        {
          // まずはオンライン健康相談を取得
          const params = {
            from_user_id: reserve.from_user_id,
            orderBy: 'asc',
            progress: 1,
            withWho5: true,
            withType: true,
            withMeeting: true,
            isUserWatch: 1,
            isRisk: 1,
            counseling_type: 1, // オンライン健康相談
          };
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params,
          });
          const res = response.data.result.data;
          res.forEach((data) => { // 該当予約以外の予約
            if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
              futureReserve.push(data);
            }
          });
        }

        {
          // 続いてバーチャル健康相談を取得
          const virtualParams = {
            from_user_id: reserve.from_user_id,
            orderBy: 'asc',
            progress: 1,
            withWho5: true,
            withType: true,
            withMeeting: true,
            isUserWatch: 1,
            isRisk: 1,
            counseling_type: 3, // バーチャル健康相談
          };
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params: virtualParams,
          });
          const res = response.data.result.data;
          res.forEach((data) => { // 該当予約以外の予約
            if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
              futureReserve.push(data);
            }
          });
        }

        // 日付順にソートしてセット
        if (futureReserve.length === 0) {
          return;
        }
        this.futureReserveMap[reserve.id] = futureReserve.sort((a, b) => moment(a.schedule.date).diff(moment(b.schedule.date)));

      } catch (error) {
        if (error.message) console.log(error);
        else console.log(error);
      }
    },


    /** 学校管理者のキャンセル処理 */
    cancelReserve(reserve) {
      const args = {
        modalName: 'reserveCancel',
        data: {
          reserve_id: reserve.id,
          counseling_type: this.reserveCounselingTypes[reserve.id],
          schedule: reserve.schedule,
          customer_id: reserve.fromUser?.customer_id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: null });
    },

    /** userBox背景色指定用 */
    userBoxColor(user) {
      let color;
      if (user && user.risk && user.risk.length && user.risk[user.risk.length - 1].type !== 11) {
        color = 'red';
      } else {
        color = 'white';
      }
      return color;
    },

    getTeacherReserveURL(reserveId) {
      return this.isVirtual(reserveId) ? `/teacher/reserve/virtual/${reserveId}` : `/teacher/reserve/online/${reserveId}`;
    },

    registReadFlag(id) {
      const data = {
        model_type: 3,
        user_id: this.user.id,
        foreign_id: id,
      };
      this.axios({
        method: 'POST',
        url: '/v1/readflag/set/register',
        data,
      })
        .then(() => {
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module>
.label {
  width: 105px;
  min-width: 105px;
  margin-right: 20px;
  @include sm-view {
    width: 100%;
  }
}
.postUser {
  // メモ本文の上に投稿者氏名＋最終更新日時を表示
  font-weight: bold;
  font-size: 13px;
}
.user {
  display: flex;
  align-items: center;
}
.img {
  margin-right: 10px;
}
.icon {
  cursor: pointer;
  font-size: 20px;
  color: var(--gray-side);
  &_wrap {
    @include sm-view {
      text-align: right;
    }
  }
}
.detail {
  li {
    display: flex;
    align-items: flex-start;
    .content {
      // font-size: 14px;
      margin-top: 3px;
      flex: 1;
      // 学校メモ・事務局メモ・相談内容など長文表示の折り返し（#3244）
      word-break: break-all;
      overflow-wrap: break-word;
    }
    &:not(:last-child) {
      margin-bottom: 12px;
    }
    @include sm-view {
      display: block;
      font-size: 13px;
    }
  }
}
.cancel {
  margin-left: 5px;
  font-size: 10px;
  color: var(--pink);
}
.types {
  margin-right: 20px;
}
.who5 {
  li {
    justify-content: space-between;
  }
  &_answer {
    font-weight: bold;
  }
}
.time {
  display: flex;
  align-items: center;
  font-weight: bold;
  i {
    font-size: 20px;
    margin-right: 6px;
  }
  div {
    margin-left: 12px;
  }
}
.counseling {
  display: flex;
  align-items: center;
  &_wrap {
    display: flex;
    align-items: center;
  }
  &_icon {
    font-size: 25px !important;
    position: relative;
    &_inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      font-size: 10px !important;
    }
  }
}
.value {
  flex: 1;
  margin-top: 3px;
  &.type {
    display: flex;
    flex-wrap: wrap;
    p {
      white-space: nowrap;
      &:not(:last-child) {
        &::after {
          margin: 0 5px;
          content: '/';
        }
      }
      // 「その他」自由記述などで長い半角英字連続が来た時の折り返し（#3244）
      > span {
        word-break: break-all;
        overflow-wrap: break-word;
        white-space: normal;
        // 自由記述は本文 bold とは別の通常重みで表示する
        font-weight: normal;
      }
    }
  }
  // sub_type が保存されているレコード（企業ユーザー）はメインを縦並びにしてセパレータを消す
  &.typeCompany {
    display: block;
    p {
      white-space: normal;
      &:not(:last-child)::after {
        content: '';
        margin: 0;
      }
    }
  }
}
.virtualcast_url {
  font-size: 10px;
}
.counseling_icon {
  &.online {
    color: var(--orange-main);
  }
  &.virtual {
    color: var(--green-main);
  }
}
.new {
  position: absolute;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;
  top: -10px;
  right: -10px;
  &_wrap {
    position: relative;
  }
}

.fReserve {
  &_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_label {
    background-color: var(--gray-sub);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding: .3em 1em;
    border-radius: 5px;
    width: 140px;
  }
  &_value {
    padding-left: 1em;
  }
  &_center {
    align-items: stretch !important;
  }
  &_none {
    display: flex;
    align-items: center;
  }
}
// 過去予約の <span> も企業ユーザー時は縦並びにしてサブが見やすいように
.fReserveTypeCompany {
  display: block;
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する。
// 表示形は予約入力の確認ステップ（ReserveFormWizard の確認欄）に合わせてある。
// span を block 化して親 <p> 内で改行させる。テンプレ側は1行で書くこと
// （親に white-space: pre-wrap が効く画面があり、改行・インデントが空白として可視化されるため）。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}
</style>
